import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import LandingPage from './landing/LandingPage';
import { LANDING_BY_PATH } from './landing/templates';
import About from './landing/About';
import Contact from './landing/Contact';
import Terms from './landing/Terms';
import Privacy from './landing/Privacy';
import SpecialPage from './landing/SpecialPage';

const path = window.location.pathname.replace(/\/+$/, '') || '/';
const template = LANDING_BY_PATH[path];

const isLandingPage = Boolean(template);
const isSpecialPage = path === '/about' || path === '/contact' || path === '/terms' || path === '/privacy';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {isLandingPage ? <LandingPage template={template} />
      : isSpecialPage ? <SpecialPage path={path} />
      : <App />}
  </React.StrictMode>
);